import { babyface } from '../CDNUrl';

const EVENT_BANNER_URI = `${babyface}/event/event_banner`;
const EVENT_DETAIL_URI = `${babyface}/event_detail/friend`;

export const EVENT_BANNER_MO_FRIEND = `${EVENT_BANNER_URI}_mobile_friend.webp`;
export const EVENT_BANNER_PC_FRIEND = `${EVENT_BANNER_URI}_pc_friend.png`;
export const EVENT_BANNER_ALT_FRIEND = '친구추천 이벤트 배너';

export const EVENT_DETAIL_MO_FRIEND = `${EVENT_DETAIL_URI}_mobile.webp`;
export const EVENT_DETAIL_PC_FRIEND = `${EVENT_DETAIL_URI}_pc.png`;
export const EVENT_DETAIL_ALT_FRIEND = '친구추천 이벤트';
